import { Navigate, Outlet, useNavigate } from "react-router-dom";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { ScreenLoaderLogo } from "~/components/screen/screen-loader-logo";
import { logger } from "~/services/logger";
import { ScannerListener, scanToastError } from "~/components/scanner-listener";
import { useIdentifyUser } from "~/hooks/use-identify-user";
import { collectActions } from "~/providers/store/collect/actions";
import {
  useIsEmployeeAuthenticated,
  type UserIdentifier
} from "~/providers/store/employee";

import { CollectTillProvider } from "./collect-till-context";

export const CollectLayoutPage = () => {
  const { data: till, status } = useCurrentTill();

  if (status === "pending") {
    return <ScreenLoaderLogo />;
  }

  if (till?.type !== "collect" && till?.type !== "collect-lite") {
    logger.warn("Till is not collect or collect-lite", {
      till_id: till?.id,
      till_type: till?.type
    });
    return <Navigate to="/profiles" />;
  }

  return (
    <CollectTillProvider till={till}>
      <Outlet />

      <CollectScannerListener />
    </CollectTillProvider>
  );
};

const CollectScannerListener = () => {
  const { mutate: identifyUser } = useIdentifyUser();
  const isUserAuthenticated = useIsEmployeeAuthenticated();
  const navigate = useNavigate();

  const handleIdentifyUser = (value: UserIdentifier | string) => {
    let userIdentifier: UserIdentifier;
    if (typeof value === "string") {
      userIdentifier = { type: "child-card-hex", value };
    } else {
      userIdentifier = value;
    }

    identifyUser(
      { userIdentifier, diningOption: null },
      {
        onSuccess: (data) => {
          if (!data.user) {
            throw new Error("User not found");
          }

          collectActions.setFlow("collect");
          navigate(
            `/collect/orders?childId=${
              data.user.childId
            }&groupName=${encodeURIComponent(data.user.groupName)}`
          );
        },
        onError: (error) => {
          scanToastError(error);
        }
      }
    );
  };

  return (
    <ScannerListener
      isUserAuthenticated={isUserAuthenticated}
      enabled
      onIdentifyUser={handleIdentifyUser}
      onIdentifyProductOrUser={handleIdentifyUser}
    />
  );
};
